import { FormattedMessage } from 'react-intl';

import { cardAttributes, glossary } from '@sorare/core/src/lib/glossary';

import {
  BackendDailyFilter,
  BackendGameweekFilter,
} from '#src/searchCards/FixtureFilter/index.tsx';
import { RefineBackendCardPlayerAge } from '#src/searchCards/RefineAge/index.tsx';
import { RefineBackendAppearances } from '#src/searchCards/RefineAppearances/index.tsx';
import {
  RefineBackendActiveClub,
  RefineClub,
} from '#src/searchCards/RefineClubs/index.tsx';
import {
  RefineBackendActiveLeague,
  RefineBackendActiveNationalTeam,
  RefineBackendPlayingStatus,
  RefineBackendNationality,
  RefineBackendPlayer,
} from '#src/searchCards/RefineList/index.tsx';
import {
  RefineBackendClassicProjection,
  RefineBackendDailyProjection,
} from '#src/searchCards/RefineProjection/index.tsx';
import {
  DailyFilter,
  RefineBackendAverageScore,
  RefineBackendPosition,
} from '#src/searchCards/index.ts';
import {
  MatchInfoGroup,
  PlayerGroup,
  ProjectionGroup,
  RefineTenGameAverageScore,
} from '#src/searchCards/nba/cardFilters.tsx';

const MAX_TEAM_LIMIT = 30;

export const scoutingCenterMarketFilters = [
  MatchInfoGroup,
  PlayerGroup({ withClub: true, withoutActiveClub: true }),
  ProjectionGroup(),
];

export const scoutingCenterMarketDropdownFilters = [
  RefineClub(MAX_TEAM_LIMIT),
  DailyFilter,
  RefineTenGameAverageScore,
];

export const scoutingCenterBackendMarketFilters = [
  {
    slug: 'match-info',
    title: <FormattedMessage {...glossary.matchInfo} />,
    filters: [
      BackendGameweekFilter,
      RefineBackendAverageScore({ disableFiveAverageScore: true }),
      RefineBackendAppearances(),
    ],
  },
  {
    slug: 'player',
    title: <FormattedMessage {...cardAttributes.player} />,
    filters: [
      RefineBackendPosition(),
      RefineBackendPlayingStatus,
      RefineBackendCardPlayerAge,
      RefineBackendNationality,
      RefineBackendPlayer,
      RefineBackendActiveLeague(),
      RefineBackendActiveClub(),
      RefineBackendActiveNationalTeam,
    ],
  },
  {
    slug: 'projection',
    title: <FormattedMessage {...glossary.projection} />,
    filters: [RefineBackendDailyProjection, RefineBackendClassicProjection],
  },
];

export const scoutingCenterBackendMarketDropdownFilters = [
  RefineBackendActiveClub(MAX_TEAM_LIMIT),
  BackendDailyFilter,
  RefineBackendAverageScore({ disableFiveAverageScore: true }),
  RefineBackendPosition(),
];
